import { PermMedia } from "@mui/icons-material";
import Music from "./Music";
import Photos from "./Photos";
import Videos from "./Videos";

const MediaContent = {
  title: "Media",
  children: [Photos, Videos, Music],
  menu: true,
  menuIndex: 1,
  icon: <PermMedia />,
};

export default MediaContent;
